// extracted by mini-css-extract-plugin
module.exports = {"btn":"src-pages-Smeng-VerifyModal-__index-module__btn--2rhl-","des":"src-pages-Smeng-VerifyModal-__index-module__des--30NYL"};